import React from 'react';
import type { Question } from '../../../../../../types/publicForm.types';
import { V1QuestionFooter } from './V1QuestionHelpers';

interface V1TextareaQuestionProps {
  question: Question;
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  error?: string;
  primaryColor: string;
  moreInfo?: string;
  isMoreInfoExpanded?: boolean;
  onToggleMoreInfo?: () => void;
}

export const V1TextareaQuestion: React.FC<V1TextareaQuestionProps> = ({
  question,
  value,
  onChange,
  onBlur,
  error,
  primaryColor,
  moreInfo,
  isMoreInfoExpanded,
  onToggleMoreInfo,
}) => {
  // V1 serializer converts to boolean, so check both string and boolean
  const characterLimit = (question.options?.useCharacterLimit === "1" || question.options?.useCharacterLimit === true)
    ? (question.options?.characterLimit || 0) 
    : 0;
  const characterMinimum = (question.options?.useCharacterMinimum === "1" || question.options?.useCharacterMinimum === true)
    ? (question.options?.characterMinimum || 0)
    : 0;
  const currentLength = String(value).length;

  return (
    <div>
      <textarea
        id={question.id}
        placeholder=""
        value={value}
        onChange={(e) => {
          // Enforce character limit if enabled
          if (characterLimit > 0 && e.target.value.length > characterLimit) {
            return;
          }
          onChange(e.target.value);
        }}
        onBlur={onBlur}
        rows={4}
        className={`w-full border rounded-lg p-3 text-sm focus:ring-2 focus:border-transparent ${
          error ? 'border-red-500' : 'border-gray-200'
        }`}
        style={{ '--tw-ring-color': error ? '#EF4444' : primaryColor } as React.CSSProperties}
        maxLength={characterLimit > 0 ? characterLimit : undefined}
      />
      
      <V1QuestionFooter
        error={error}
        characterLimit={characterLimit}
        characterMinimum={characterMinimum}
        currentLength={currentLength}
        helpText={question.helpText || question.description}
        moreInfo={moreInfo}
        isMoreInfoExpanded={isMoreInfoExpanded}
        onToggleMoreInfo={onToggleMoreInfo}
      />
    </div>
  );
};